import {
  GlobalEvents,
  SnippetElement,
  Theme,
  defineElement,
  liquidValue,
  onClick,
  query
} from "./chunk-DNDL4K7L.js";
import {
  __async,
  __decorateClass
} from "./chunk-XDKWOSVF.js";

// src/snippets/common-line-item/common-line-item.ts
var CommonLineItem = class extends SnippetElement {
  constructor() {
    super(...arguments);
    this.isOpen = false;
    this.isToastOpen = false;
  }
  open() {
    return __async(this, null, function* () {
      this.infoPopover.open();
      this.infoPopover.style.top = `-${this.infoPopover.getBoundingClientRect().height}px`;
      this.isOpen = true;
    });
  }
  close() {
    return __async(this, null, function* () {
      this.infoPopover.close();
      this.isOpen = false;
    });
  }
  connectedCallback() {
    var _a;
    (_a = this.variantQty) == null ? void 0 : _a.addEventListener("keydown", (event) => {
      if (event.key === "Enter") {
        this.saveQuantity();
      }
    });
  }
  toggleButton() {
    if (this.isToastOpen) {
      this.closeToast();
    } else {
      this.openToast();
    }
  }
  saveQuantity() {
    return __async(this, null, function* () {
      var _a, _b;
      (_a = this.quantityAccordionSave) == null ? void 0 : _a.setAttribute("loading", "");
      yield Theme.Cart.updateLineItem(this.key, this.variantQty.valueAsNumber);
      GlobalEvents.emit("cart:updated");
      (_b = this.quantityAccordionSave) == null ? void 0 : _b.removeAttribute("loading");
      this.closeToast();
    });
  }
  openToast() {
    return __async(this, null, function* () {
      var _a, _b, _c;
      this.isToastOpen = true;
      (_a = this.quantityAccordion) == null ? void 0 : _a.open();
      (_b = this.quantityAccordionToggle) == null ? void 0 : _b.classList.add("!opacity-0");
      (_c = this.quantityAccordionSave) == null ? void 0 : _c.classList.add("!opacity-100", "!block");
    });
  }
  closeToast() {
    return __async(this, null, function* () {
      var _a, _b, _c;
      this.isToastOpen = false;
      (_a = this.quantityAccordion) == null ? void 0 : _a.close();
      (_b = this.quantityAccordionToggle) == null ? void 0 : _b.classList.remove("!opacity-0");
      (_c = this.quantityAccordionSave) == null ? void 0 : _c.classList.remove("!opacity-100", "!block");
    });
  }
  toggle() {
    return __async(this, null, function* () {
      if (this.isOpen) {
        yield this.close();
      } else {
        yield this.open();
      }
    });
  }
  addQuantity() {
    return __async(this, null, function* () {
      var _a, _b;
      (_a = this.increaseBtn) == null ? void 0 : _a.setAttribute("loading", "");
      this.variantQty.valueAsNumber += 1;
      yield Theme.Cart.updateLineItem(this.key, this.variantQty.valueAsNumber);
      GlobalEvents.emit("cart:updated");
      (_b = this.increaseBtn) == null ? void 0 : _b.removeAttribute("loading");
    });
  }
  reduceQuantity() {
    return __async(this, null, function* () {
      var _a, _b;
      if (this.variantQty.valueAsNumber === 1) {
        yield this.removeItem();
      } else {
        (_a = this.decreaseBtn) == null ? void 0 : _a.setAttribute("loading", "");
        this.variantQty.valueAsNumber -= 1;
        yield Theme.Cart.updateLineItem(this.key, this.variantQty.valueAsNumber);
        GlobalEvents.emit("cart:updated");
        (_b = this.decreaseBtn) == null ? void 0 : _b.removeAttribute("loading");
      }
    });
  }
  removeItem() {
    return __async(this, null, function* () {
      var _a;
      (_a = this.removeBtn) == null ? void 0 : _a.setAttribute("loading", "");
      yield Theme.Cart.removeLineItem(this.key);
      GlobalEvents.emit("cart:updated");
    });
  }
};
__decorateClass([
  liquidValue("item.key")
], CommonLineItem.prototype, "key", 2);
__decorateClass([
  query("[data-cart-quantity]")
], CommonLineItem.prototype, "variantQty", 2);
__decorateClass([
  query("[data-remove]")
], CommonLineItem.prototype, "removeBtn", 2);
__decorateClass([
  query("[data-cart-quantity-plus")
], CommonLineItem.prototype, "increaseBtn", 2);
__decorateClass([
  query("[data-cart-quantity-minus")
], CommonLineItem.prototype, "decreaseBtn", 2);
__decorateClass([
  query("[data-info-popover]")
], CommonLineItem.prototype, "infoPopover", 2);
__decorateClass([
  query("[data-quantity-accordion]")
], CommonLineItem.prototype, "quantityAccordion", 2);
__decorateClass([
  query("[data-quantity-accordion-toggle]")
], CommonLineItem.prototype, "quantityAccordionToggle", 2);
__decorateClass([
  query("[data-quantity-accordion-save]")
], CommonLineItem.prototype, "quantityAccordionSave", 2);
__decorateClass([
  onClick("[data-quantity-accordion-toggle]")
], CommonLineItem.prototype, "toggleButton", 1);
__decorateClass([
  onClick("[data-quantity-accordion-save]")
], CommonLineItem.prototype, "saveQuantity", 1);
__decorateClass([
  onClick("[data-info-btn]")
], CommonLineItem.prototype, "toggle", 1);
__decorateClass([
  onClick("[data-cart-quantity-plus]")
], CommonLineItem.prototype, "addQuantity", 1);
__decorateClass([
  onClick("[data-cart-quantity-minus]")
], CommonLineItem.prototype, "reduceQuantity", 1);
__decorateClass([
  onClick("[data-remove]")
], CommonLineItem.prototype, "removeItem", 1);
CommonLineItem = __decorateClass([
  defineElement("common-line-item")
], CommonLineItem);
export {
  CommonLineItem
};
